import React from 'react'
import { ImgContainer, ThankYouContainer, ThankYouText, Text, LinkTitle } from './Styles';
import Logo from '../../../../../assets/images/clinic.png';
import ClinicForms from '../../ClinicInfoForms/ClinicForms';
import { Link as RouterLink } from 'react-router-dom';


const ThankYou = () => {

    return (
        <ThankYouContainer>
            <ImgContainer src={Logo} alt="Clinic Logo" />

            <ThankYouText>
                Thank You For Adding Profile Details!
            </ThankYouText>
            <Text sx={{ fontSize: '14px' }}>
                Would you like to Add Your Clinic Details?
            </Text>
            <LinkTitle to="/public/clinicProfile">
                Click Here!
            </LinkTitle>

        </ThankYouContainer>
    )
}

export default ThankYou
